import merge from "lodash/merge";

class Invoice {
  constructor() {
    this.ID = 0,
    this.FPLX = "",//发票类型 数电专 数电普
    this.GMF_NSRSBH = "",//购方纳税人编号
    this.GMF_MC = "",//购方名称
    this.GMF_DZ = "",//购方地址
    this.GMF_DH = "",//购方电话
    this.GMF_YH = "",//购方银行
    this.GMF_ZH = "",//购方账号
    this.GMF_SJH = "",//购方手机号
    this.GMF_DZYX = ""//购买方电子邮箱
    this.JSHJ = "",//价税合计
    this.HJJE = "",//合计金额
    this.HJSE = ""//合计税额
    this.BZ = ""//备注
    this.COMMON_FPKJ_XMXXS = []//发票明细
    this.TITLE_TYPE = ""//抬头类型
    this.SFZSXSFYHZH = "" // 是否展示销售方银行账号
    this.SFZSXSFDZDH = "" // 是否展示销售方地址电话
    this.SFZSGMFYHZH = "" // 是否展示购买方银行账号
    this.SFZSGMFDZDH = "" // 是否展示购买方地址电话
    this.signup_id = 0
  }
  static getInvoiceList(filters) {
    const url = process.env.VUE_APP_API_URL + 'api/v1/invoiceloc'
    if (!filters.per_page || filters.per_page == '') {
      filters.per_page = -1
    }
    return axios.get(url, { params: filters }).then((res) => {
      let result = {}
      result.invoice_list = Array()
      res.data.results.forEach((x) => {
        let c = new Invoice()
        Object.assign(c, x)
        result.invoice_list.push(c)
      })
      result.total = res.data.total
      return result
    })
  }
  static getInvoiceLoginfo(filters){
    const url = process.env.VUE_APP_API_URL + 'api/v1/invoice/loginfo'
    return axios.get(url,{params:filters}).then(res=>{
      return res.data
    })
  }
  createOrUpdateInvoice() {
    const url =
      process.env.VUE_APP_API_URL + "api/v1/invoice"
      if (this.ID == 0) {
        //新增
        const data = merge({}, this);
        return axios.post(url, data).then((res) => {
          console.log(res)
          return res.data;
        });
      }
    }
    static queryPdf(invoiceid){
      const url =
        process.env.VUE_APP_API_URL + "api/v1/invoice/querypdf"
        const data = {"id":invoiceid};
        return axios.post(url, data).then((res) => {
          console.log(res.data)
          return res.data;
        });
      }
    static redflushInvoice(paid_order_id) {
      const url =
        process.env.VUE_APP_API_URL + "api/v1/invoice/redflush"
      const data = {"paid_order_id":paid_order_id};
      return axios.post(url, data).then((res) => {
        return res.data;
      });
    }
    
    static isInvoiced(signup_id){
      const url =
        process.env.VUE_APP_API_URL + "api/v1/invoice/isinvoiced"
        return axios.get(url, { params: {"signup_id":signup_id} }).then((res) => {
          return res.data;
        });
  }

  static getTaxno(taxname){
    const url =
    process.env.VUE_APP_API_URL + "api/v1/invoice/gettaxno"
    const data = {"taxname":taxname};
      return axios.post(url, data).then((res) => {
        return res.data;
      });
  }
}
export { Invoice };